import React, { useState } from 'react';
import { useRecordContext } from 'react-admin';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
} from '@mui/material';

const formatDate = (dateStr) =>
  dateStr ? new Date(dateStr).toLocaleDateString() : 'N/A';

const LabelValue = ({ label, value }) => (
  <>
    <Grid item xs={4}>
      <Typography variant="body2" fontWeight="bold" color="textSecondary">
        {label}
      </Typography>
    </Grid>
    <Grid item xs={8}>
      <Typography variant="body2">{value ?? 'N/A'}</Typography>
    </Grid>
  </>
);

const InvoiceDialog = () => {
  const record = useRecordContext();
  const [open, setOpen] = useState(false);

  if (!record) return null;

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
  
 <Typography
              onClick={handleOpen}
              variant="body2"
              color="primary"
              sx={{ textDecoration: 'underline', cursor: 'pointer', display: 'inline' }}
            >
         {record.id}
      </Typography>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Invoice Details</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <LabelValue label="Invoice ID" value={record.id} />
            <LabelValue label="Quantity" value={record.quantity} />
            <LabelValue label="Amount" value={record.amount} />
            <LabelValue label="Status" value={record.status} />
            <LabelValue label="Due Date" value={formatDate(record.dueDate)} />
            <LabelValue label="Delivery Place" value={record.deliveryPlace} />
            <LabelValue label="Delivery Responsibility" value={record.deliveryResponsibility} />
            <LabelValue label="Payment Terms" value={record.paymentTerms} />
            <LabelValue label="Notes" value={record.notes} />
            <LabelValue label="Rejection Reason" value={record.rejectionReason} />
            <LabelValue label="Created At" value={formatDate(record.created_at)} />
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained">Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default InvoiceDialog;
